module.exports = __webpack_public_path__ + "img/welfare-zbit.030c47e0.png";